<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <p>{{ message }}</p>
  <p *ngIf="timeLeft">
    Ending session in <span class="time-left-text">{{ timeLeft }}</span> seconds
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="warn" (click)="end()">End</button>
  <button mat-button color="success" (click)="continue()">Continue</button>
</mat-dialog-actions>
